import vaseIcon from "images/circleIcons/valentines/vase.png";
import silverIcon from "images/circleIcons/valentines/silver.png";
import candyHeartIcon from "images/circleIcons/valentines/candyHeart.png";
import bowIcon from "images/circleIcons/valentines/bow.png";
import engagementRingIcon from "images/circleIcons/valentines/engagementRing.png";
import stampIcon from "images/circleIcons/valentines/stamp.png";
import chocolateIcon from "images/circleIcons/valentines/chocolate.png";
import goldEarringsIcon from "images/circleIcons/valentines/goldEarrings.png";
import roseIcon from "images/circleIcons/valentines/rose.png";
import breakableHeartIcon from "images/circleIcons/valentines/breakableHeart.png";

const questionAnswers = [
  {
    title: "DEMAND CURVE FOR CANDY HEARTS",
    question:
      "There are rumors that candy hearts will be discontinued in a year from now.",
    subQuestion: "Consider the demand curve for candy hearts. What happens?",
    icon: candyHeartIcon,
    answer: "shifts right",
    graphType: "demand curve",
    briefness:
      "If consumers expect that candy hearts may disappear next year, they will stock up and purchase more now. This will cause an increase in demand, and the demand curve will shift to the right.",
  },
  {
    title: "DEMAND CURVE FOR BOWS",
    question: "The price of arrows increase.",
    subQuestion: "Consider the demand curve for bows. What happens?",
    icon: bowIcon,
    answer: "shifts left",
    graphType: "demand curve",
    briefness:
      "Bows and arrows are complements. As the price of arrows increases, the quantity demanded will decrease. Demand for bows—a complement—will decrease. The demand curve for bows will shift to the left.",
  },
  {
    title: "DEMAND CURVE FOR ENGAGEMENT RINGS",
    question:
      "Cheaper diamond extraction technology causes the price of engagement rings to fall.",
    subQuestion:
      "Consider the demand curve for engagement rings. What happens?",
    icon: engagementRingIcon,
    answer: "goes up",
    graphType: "demand curve",
    briefness:
      "A price change does not affect the demand curve. We should expect to see an increase in the quantity demanded for engagement rings.",
  },
  {
    title: "DEMAND CURVE FOR STAMPS",
    question:
      "Star crossed lovers switch from writing love letters to writing love emails.",
    subQuestion: "Consider the demand curve for stamps. What happens?",
    icon: stampIcon,
    answer: "shifts left",
    graphType: "demand curve",
    briefness:
      "As individuals (and star crossed lovers) move away from letter writing in favor of electronic communication, demand for stamps will decrease. The demand curve for stamps will shift to the left.",
  },
  {
    title: "DEMAND CURVE FOR DARK CHOCOLATE",
    question: "New research shows consuming dark chocolate can reduce stress.",
    subQuestion: "Consider the demand curve for dark chocolate. What happens?",
    icon: chocolateIcon,
    answer: "shifts right",
    graphType: "demand curve",
    briefness:
      "If dark chocolate is perceived as healthier (or less unhealthy), this will increase demand and the demand curve for dark chocolate will shift to the right.",
  },
  {
    title: "DEMAND CURVE FOR BREAKABLE CHOCOLATE HEARTS",
    question:
      'Kim K recommends getting your loved one a "breakable chocolate heart" this year.',
    subQuestion:
      "Consider the demand curve for breakable chocolate hearts. What happens?",
    icon: breakableHeartIcon,
    answer: "shifts right",
    graphType: "demand curve",
    briefness:
      "If Kim K or other famous people recommend goods or services, this can sway public opinion. Kim K's endorsement of the breakable chocolate hearts will increase demand and the demand curve will shift to the right.",
  },
];

export default questionAnswers;
